import {
  Card,
  Eyebrow,
  List,
  PageHeaderSkeleton,
  Skeleton,
  Stack,
} from '@leanin/ui';
import { GroupRowSkeleton } from '../../cards/GroupRow.skeleton';

export function NetworkCirclesSectionSkeleton({
  rows = 3,
}: {
  rows?: number;
}) {
  return (
    <Stack gap="lg">
      <PageHeaderSkeleton />

      <Card pad="default">
        <Stack gap="md">
          <Eyebrow tone="accent">Add a Circle</Eyebrow>
          <Skeleton height={36} rounded="md" />
        </Stack>
      </Card>

      <Card pad="flush">
        <List bordered={false}>
          {Array.from({ length: rows }, (_, i) => (
            <GroupRowSkeleton key={i} />
          ))}
        </List>
      </Card>
    </Stack>
  );
}
